// import { useContext } from "react"
// import { ObraContext } from "../context/ObraContext"

const Obra = ( { obras} ) => {

  

  return (
    <>
      {
        obras.map( (obra,i) => (
          <div key={i}>
            <p className="mx-4 text-justify">{obra.nombre}</p>
          </div>
        ))
      }
    </>
  )
}

export default Obra